import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { R4Service } from '../../../services/r4.service';

export interface R4MontoModalData {
  montoMin: number;
  montoMax: number;
}

@Component({
  selector: 'app-r4-monto-min-modal',
  templateUrl: './r4-monto-min-modal.component.html',
  styles: [],
})
export class R4MontoMinModalComponent {
  montoMin: number;
  montoMax: number;
  loading = false;

  constructor(
    private r4Service: R4Service,
    public dialogRef: MatDialogRef<R4MontoMinModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: R4MontoModalData,
  ) {
    this.montoMin = data?.montoMin ?? 0;
    this.montoMax = data?.montoMax ?? 500000;
  }

  guardar(): void {
    if (this.loading) return;
    const min = Number(this.montoMin);
    const max = Number(this.montoMax);
    if (!(min >= 0) || !(max > 0)) {
      Swal.fire({ icon: 'warning', title: 'Valores inválidos', text: 'Min ≥ 0 y Max > 0.' });
      return;
    }
    if (min > max) {
      Swal.fire({ icon: 'warning', title: 'Rango inválido', text: 'El tope operativo (min) no puede superar el tope duro (max).' });
      return;
    }
    this.loading = true;
    this.r4Service.setMonto(min, max).subscribe({
      next: () => {
        this.loading = false;
        Swal.fire({ icon: 'success', title: 'Montos actualizados', timer: 2000, showConfirmButton: false });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({ icon: 'error', title: 'Error', text: typeof err === 'string' ? err : 'No se pudo guardar' });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
